/* istanbul ignore file */
export * from './InstallmentCalulatorInCard';
